import { reflect } from '@effector/reflect';
import { CircleSlash2 } from 'lucide-react';
import { not, equals } from 'patronum';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { BlockBonusModel } from 'features/block-bonus/model';
import { viewerModel } from 'entities/viewer';
import { USER_ROLES } from 'shared/api';
import { createConfirmModal, ConfirmModalProps } from 'shared/ui';

export const createBlockBonusModal = (model: BlockBonusModel) => {
	const ConfirmModal = createConfirmModal(model);

	const BlockBonusModal = forwardRef<HTMLDivElement, ConfirmModalProps>(({ ...props }, ref) => {
		const { t } = useTranslation();

		return (
			<ConfirmModal
				ref={ref}
				title={t('block-bonus.title')}
				cancelButtonProps={{
					children: t('block-bonus.cancel'),
				}}
				submitButtonProps={{
					variant: 'outline',
					children: t('block-bonus.block'),
				}}
				{...props}
			>
				{t('block-bonus.description')}
			</ConfirmModal>
		);
	});

	const BlockBonusModalActionIcon = reflect({
		view: ConfirmModal.ActionIcon,
		bind: {
			'data-test-id': 'block-bonus-action-icon',
			variant: 'ghost-secondary',
			disabled: not(equals(viewerModel.$role, USER_ROLES.god)),
			children: <CircleSlash2 />,
		},
	});

	return Object.assign(BlockBonusModal, {
		ActionIcon: BlockBonusModalActionIcon,
	});
};
